import { render, staticRenderFns } from "./OfferFinishedHandSanitizer.vue?vue&type=template&id=63e67c33&scoped=true&"
import script from "./OfferFinishedHandSanitizer.vue?vue&type=script&lang=js&"
export * from "./OfferFinishedHandSanitizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e67c33",
  null
  
)

export default component.exports